import React, { useState } from "react";
import styled from "styled-components";
import Typography from "../typography";
import { Colors } from "../../utils/colors";

interface IProps {
  q: string;
  a: string;
}
const FAQElement = ({ q, a }: IProps) => {
  const [open, setOpen] = useState(false);
  return (
    <Container open={open ? "true" : "false"}>
      <Top>
        <QuestionText>
          <Typography
            weight="medium"
            size="xl"
            m_size="lg"
            color={Colors.white300}
          >
            {q}
          </Typography>
        </QuestionText>
        <Icon onClick={() => setOpen(!open)}>
          {open ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M8.5 12H16.5M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12Z"
                stroke="#4E4E4E"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M12.5 8V16M8.5 12H16.5M22.5 12C22.5 17.5228 18.0228 22 12.5 22C6.97715 22 2.5 17.5228 2.5 12C2.5 6.47715 6.97715 2 12.5 2C18.0228 2 22.5 6.47715 22.5 12Z"
                stroke="#4E4E4E"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          )}
        </Icon>
      </Top>
      <Bottom open={open ? "true" : "false"}>
        <Typography size="lg" m_size="m" color={Colors.grey500}>
          {a}
        </Typography>
      </Bottom>
    </Container>
  );
};

export default FAQElement;

const Container = styled.div<{ open: string }>`
  width: 100%;
  height: ${(props) => (props.open === "true" ? "fit-content" : "5rem")};
  overflow: hidden;
  border-bottom: 1px solid ${Colors.grey700};
  padding-bottom: 3.2rem;
  transition: all ease-in-out 0.2s;
`;

const Top = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const QuestionText = styled.div`
  width: 85%;
`;

const Icon = styled.div`
  cursor: pointer;
  width: 2.4rem;
  height: 2.4rem;
`;

const Bottom = styled.div<{ open: string }>`
  margin-top: 0.8rem;
  width: 85%;
  opacity: ${(props) => (props.open === "true" ? "1" : "0")};
`;
